import useIsPortfolioReadOnly from '@/components/ChallengePortfolio/NormalView/useIsPortfolioReadonly';
import FieldName from '../utils/FieldName';
import AddTags from './AddTags';
import AttachedTags from './AttachedTags';
import TagsWrapper from './TagsWrapper';

const TagsField = () => {
  const portfolioIsReadonly = useIsPortfolioReadOnly();

  return (
    <section>
      <FieldName />
      <TagsWrapper>
        <AttachedTags />
        {!portfolioIsReadonly && <AddTags />}
      </TagsWrapper>
    </section>
  );
};

export default TagsField;
